export enum Rating {
    Null = -1,
    VeryPoor = 1,
    Poor = 2,
    Fair = 3,
    Good = 4,
    Fantastic = 5,
}
export enum Reason {
    QualityOfLiveVideo = 0,
    DealersProfessionalism = 4,
    QualityOfLiveSound = 5,
    LoadingSpeedOfGraphicsAndAnimations = 6,
    OverallExperience = 8
}
